import { Monitor } from './Monitor';

export class LicenseMonitor extends Monitor {
  public get licenseId(): string | undefined {
    return this.response?.licenseId;
  }
}
